'use strict'

import Vue from 'vue'
import axios from 'axios'
import apiConfig from '../config/api'

export const config = {
  baseURL: apiConfig.url,
  timeout: 60 * 1000, // Timeout
  withCredentials: true // Check cross-site Access-Control
}

const axiosInstance = axios.create(config)

axiosInstance.interceptors.request.use(
  function (config) {
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response?.status === 401 || false) {
      await Vue.swal('Failed', 'Your token is not valid, logging out now.', 'error')
      return
    }
    return Promise.reject(error)
  }
)

export const AxiosPlugin = {
  install: (Vue, options) => {
    Vue.axios = axiosInstance
    window.axios = axiosInstance
    Object.defineProperties(Vue.prototype, {
      axios: {
        get () {
          return axiosInstance
        }
      },
      $axios: {
        get () {
          return axiosInstance
        }
      }
    })
  }
}

Vue.use(AxiosPlugin)
export { axiosInstance }
export default AxiosPlugin
